export default "__VITE_ASSET__CjRBz2_q__"